import React, { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import money from "../../../../assets/Images/1635d86b32b60583e7f022b9c3324b3d.png";
import payimg from "../../../../assets/Images/pay.png";
import Dones from "../../../../assets/Images/success-image.png";
import api from "../../../../features/auth/axiosConfig";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CommonButtons from "../../../../shared/components/CommonButtons";
import OrderProductsList from "./order-display/components/OrderProductsList";
import OrderCustomerInfo from "./order-display/components/OrderCustomerInfo";
import OrderPriceDetails from "./order-display/components/OrderPriceDetails";
import OrderPaymentMethods from "./order-display/components/OrderPaymentMethods";
import PaymentSummaryModal from "./order-display/modals/PaymentSummaryModal";
import CashPaymentSummaryModal from "./order-display/modals/CashPaymentSummaryModal";
import PaymentConfirmModal from "./order-display/modals/PaymentConfirmModal";
import CancelOrderDialog from "./order-display/modals/CancelOrderDialog";
import { getOrdersApi, getLedgerByCustomerIdApi } from "./order-display/api";
import { useOrderDisplay } from "../../../../shared/hooks/useOrderDisplay";
import { date, orderback, Doneorder, formatNumber, formatNumbers, SendMail, SendMessage, COMPLETE, Update, Cancel, OrderUpdate, orderemailmsg } from "./order-display/orderHelpers";
import { cancelOrder, handleChange, updateCustomerEmail, validateAndSetEmail } from "./order-display/services/orderServices";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { useCustomer } from "src/business-types/laundry/modules/home/Done/hooks/useCustomer";
import { useUser } from "src/shared/context/UserContext";
import { Order, CustomerData } from "src/shared/services/interfacev2";
import { splitDateTime } from "src/shared/components/dateTime";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

const OrderDisplay: React.FC = () => {
  const [getorder, setGetOrder] = useState<Order>();
  const [bproducts, setbuttonname] = useState<Order>();
  const [confirmemail, setconfirmemail] = useState("");
  const [email, setEmail] = useState("");
  const [geterror, setGeterror] = useState<any>("");
  const [move, setmove] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [agent, setAgent] = useState<boolean>(false);
  const [customer, setCustomerData] = useState<CustomerData>();
  const [ordersucess, setOrdersucess] = useState<Order>();
  const [showPaymentMethods, setShowPaymentMethods] = useState<string>("");
  const [outstangingamount, setoutstangingamount] = useState<CustomerData>();
  const [, setemployeesData] = useState(false);
  const [logo, setlogo] = useState<any>();
  const [time, setTime] = useState({ hours: "", minutes: "", seconds: "", day: "", month: "", year: "" });
  const navigate = useNavigate();
  const { orderid } = useParams();
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancelData, setCancelData] = useState<string>("refund");
  const { user, userConfigration } = useUser();
  // const { customerData } = useCustomer(getorder?.orders[0].customerId || bproducts?.orders[0].customerId);
  const customerId = getorder?.orders[0]?.customerId || bproducts?.orders[0]?.customerId;
  const { customerData, clientId: filteredCustomerId } = useCustomer(customerId);
  const { sidebarThemeClass } = useUserTheme();
  // const { cancelLoading, setCancelLoading } = useState<boolean>(false);

  const {
    printData,
    Remainingpayments,
    Receivedbalance,
    remaining,
    discountValue,
    roundValue,
    cashoutstanging,
    Outamount,
    refundAmount,
    handleclick,
    handleBlur,
    outstandingvalue,
    payments,
    inputValue,
    condition,
    model,
    glowery,
    confirm,
    setmodel,
    setglowery,
    setConfirm,
    setPrintHistory,
    setpaylate,
    setcashpay,
    setpaycard,
    paylate,
    cashpay,
    paycard,
  } = useOrderDisplay({ bproducts, orderid: orderid || "", logo, outstangingamount: Number(outstangingamount ?? 0), getorder, sessionStorage });

  // const { clientId: filteredCustomerId } = useCustomer(getorder?.orders[0].customerId || bproducts?.orders[0].customerId);

  // useEffect(() => {
  //   date(setTime);
  //   const storedColor = user?.themes.backgroundColour;
  //   const ffamily = user?.themes.fontFamily;
  //   if (ffamily) {
  //     setffamily(ffamily);
  //     document.documentElement.style.setProperty("--fontfamily", ffamily);
  //   }
  //   if (storedColor) {
  //     document.documentElement.style.setProperty("--background-color", storedColor);
  //   }
  // }, []);

  useEffect(() => {
    date(setTime);
    getOrdersIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const employee = () => {
      const employeeData = sessionStorage.getItem("employee");
      if (employeeData) {
        setemployeesData(true);
      } else {
        setemployeesData(false);
      }
    };
    employee();
    const logo = user?.profileImageUrl || "";
    setlogo(logo);
  }, []);

  const droupdown = () => {
    const handleDelivered = () => {
      toast.success("Order has been delivered successfully!", {
        style: { borderRadius: "12px", background: "#1e293b", color: "#fff" },
      });
    };

    type StatusType = "Confirm" | "In-process" | "Waiting for delivery" | "Delivered" | "Cancelled";

    const currentMove = (move as StatusType) || "Confirm";

    // Logic for available transitions (from your statusOptions)
    const availableOptions: Record<StatusType, StatusType[]> = {
      Confirm: ["Confirm", "In-process", "Waiting for delivery"],
      "In-process": ["In-process", "Waiting for delivery", "Delivered"],
      "Waiting for delivery": ["Waiting for delivery", "Delivered"],
      Delivered: ["Delivered"],
      Cancelled: ["Cancelled"],
    };

    return (
      <div className="w-full pt-1 pb-1 animate-in fade-in slide-in-from-top-4 duration-500">
        <div className="flex items-center gap-2 px-1">
          <div className="h-4 w-1 bg-slate-900 rounded-full" />
          <h3 className="text-[11px] font-black uppercase tracking-[0.15em] text-slate-500">Order status</h3>
        </div>

        {/* Action Select */}
        <div className="relative group">
          {/* <label className="absolute -top-2 left-3 px-1 bg-white text-[10px] font-bold text-slate-400 z-10">
            UPDATE STAGE
          </label> */}
          <select
            value={currentMove}
            onChange={(e) => {
              const val = e.target.value as StatusType;
              if (val === "Delivered") handleDelivered();
              handleChangeEvent(e);
            }}
            disabled={currentMove === "Delivered" || currentMove === "Cancelled"}
            className="w-full bg-white border border-slate-200 rounded-2xl px-4 py-3.5 text-sm font-semibold text-slate-700 outline-none ring-offset-2 focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 transition-all appearance-none cursor-pointer disabled:bg-slate-50 disabled:cursor-not-allowed"
          >
            {availableOptions[currentMove]?.map((opt) => (
              <option key={opt} value={opt} className="text-slate-700 font-medium">
                {opt}
              </option>
            ))}
          </select>

          {/* Custom Chevron Icon */}
          <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-slate-400 group-hover:text-slate-600 transition-colors">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        {/* Helper text for Delivered/Cancelled */}
        {(currentMove === "Delivered" || currentMove === "Cancelled") && (
          <p className="mt-3 text-center text-[10px] text-slate-400 font-medium italic">This order is finalized and cannot be modified.</p>
        )}
      </div>
    );
  };

  const getOrdersIn = async (
    options = {
      fetchCustomer: false,
      fetchLedger: true,
      showLoading: true,
    },
  ) => {
    const { fetchCustomer = false, fetchLedger = true, showLoading = true } = options;

    if (showLoading) {
      setLoading(true);
    }

    try {
      const res = await getOrdersApi(orderid!);
      const buttonData: Order = res.data.result;

      // Always set order data
      setbuttonname(buttonData);
      setOrdersucess(buttonData);
      setGetOrder(buttonData);
      setmove(buttonData?.orders[0].status || "");

      // Update showPaymentMethods based on order status
      if (buttonData?.orders[0].status.includes("Waiting for delivery")) {
        setShowPaymentMethods("true");
      } else if (buttonData?.orders[0].status === "Delivered") {
        setShowPaymentMethods(""); // Hide payment methods for delivered orders
      }

      if (fetchLedger) {
        const customerid = buttonData?.orders[0].customerId;
        if (customerid) {
          const ledgerRes = await getLedgerByCustomerIdApi(customerid);
          const osb = ledgerRes.data.ledger.totalOutstandingBalance || 0;
          setoutstangingamount(osb);
          setCustomerData(ledgerRes.data.ledger);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  const handleUpdateCustomerEmail = () => {
    updateCustomerEmail(getorder, confirmemail, ordersucess, email, setAgent, setGeterror, orderemailmsg, customerData || undefined);
  };
  const handleOrderEmailMsg = (getorder: any, email: string, received: string, orderId: string, finalAmount: number, remaining: string) => {
    const handleDone = () => {
      Doneorder();
      setConfirm(false);
    };
    if (!getorder) return;
    orderemailmsg(getorder, email, received, orderId, finalAmount, remaining, handleDone);
  };

  const handleCancel = async () => {
    // if (cancelLoading) return;

    // setCancelLoading(true);
    try {
      await cancelOrder(orderid, cancelData, getorder?.paymentHistory?.[0]?.paymentMethod, setmove);
      await getOrdersIn({
        fetchCustomer: false,
        fetchLedger: false,
        showLoading: true,
      });

      setOpenCancelDialog(false); // ✅ close AFTER success
    } catch (err) {
      console.error(err);
    } finally {
      // setCancelLoading(false);
    }
  };

  const handleChangeEvent = (event: ChangeEvent<HTMLSelectElement>) => {
    handleChange(orderid, event, setmove, () =>
      getOrdersIn({
        fetchCustomer: false,
        fetchLedger: false,
        showLoading: false,
      }),
    );
  };

  const handleConfirm = (Payment: string) => {
    const update = OrderUpdate({ getorder, condition, inputValue: Number(inputValue), outstangingamount: Number(outstangingamount), time, Payment });
    api.patch(`/app/pos/v2/order/${orderid}`, update).then((res) => {
      setmodel(false);
      setglowery(false);
      setConfirm(true);
      setPrintHistory(true);
      getOrdersIn();
    });
  };

  const customeremailid = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    validateAndSetEmail(value, setEmail, setconfirmemail);
  };
  const remainingBalance = Number(Outamount()) - condition;
  const formattedBalance = remainingBalance.toFixed(2);
  const totaloutstandingboc = Number(cashoutstanging) + Number(getorder?.orders[0].remainingAmount);

  const primaryEmail = customer?.emails?.find((e) => e.isPrimary)?.email ?? customer?.emails?.[0]?.email ?? "";

  const { date: orderDate, time: orderTime } = splitDateTime(getorder?.orderDetails[0].orderedOn.$date ?? "");
  const toBoolean = (value: any) => value === true || value === "true";

  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  return (
    <div className="flex flex-col overflow-hidden w-full">
      {/* <PageTitle title="- Order › Details" /> */}
      <div className="w-full h-full overflow-hidden ">
        <div className="thin-scrollbar w-full flex-1 flex flex-col lg:flex-row gap-2 p-1 h-full overflow-auto">
          <div className={`lg:w-4/6 w-full p-2 h-full flex flex-col overflow-x-auto shadow-inner rounded-lg ${sidebarThemeClass}`}>
            <div className="mb-1.5">
              <CommonButtons className="shadow-sm border border-gray-300" label="BACK" onClick={() => navigate(-1)} variant="secondary" icon={KeyboardReturnIcon} />
            </div>
            <div className="flex-1 min-h-0 overflow-hidden">
              <OrderProductsList products={getorder?.orderDetails.flatMap((detail) => detail.products || []) || []} />
            </div>
          </div>
          <div className={`thin-scrollbar xl:w-4/12 lg:w-5/12 w-full h-full pr-1 flex flex-col flex-shrink-0 lg:overflow-y-auto lg:overflow-x-hidden shadow-inner rounded-lg p-1 ${sidebarThemeClass}`}>
            <OrderCustomerInfo
              orderId={String(getorder?.orders[0].orderId ?? "-")}
              customerName={`${getorder?.customerDetails.firstName ?? ""} ${getorder?.customerDetails.middleName ?? ""} ${getorder?.customerDetails.lastName ?? ""}`.trim() || "-"}
              order={getorder}
            />
            <OrderPriceDetails
              roundValue={roundValue}
              totalAmount={getorder?.orders[0].orderAmount ?? 0}
              discount={discountValue ?? 0}
              deliveryFee={getorder?.orders[0].deliveryFee ?? 0}
              deliveryFeeEnabled={deliveryFeeEnabled}
              finalAmount={getorder?.orders[0].finalAmount ?? 0}
              receivedBalance={Receivedbalance ?? 0}
              remaining={remaining() ?? 0}
              outstandingAmount={Number(outstangingamount ?? 0)}
              // outstandingAmount={getorder?.totalOutstandingBalance ?? 0}
              paymentMethod={getorder?.paymentHistory?.at(-1)?.paymentMethod ?? "-"}
              orderDate={orderDate}
              orderTime={orderTime}
            />
            <OrderPaymentMethods
              droupdown={droupdown}
              showPaymentMethods={Boolean(showPaymentMethods)}
              remaining={remaining}
              outstangingamount={() => Number(outstangingamount ?? 0)}
              // outstandingAmount={() => Number(outstangingamount ?? 0)}
              payments={payments}
              getorder={getorder}
              setOpenCancelDialog={setOpenCancelDialog}
              filteredCustomerId={filteredCustomerId}
              printData={printData}
              COMPLETE={COMPLETE}
              paylate={paylate}
              cashpay={cashpay}
              setpaylate={setpaylate}
              setcashpay={setcashpay}
              paycard={paycard}
              setpaycard={setpaycard}
            />
            <CancelOrderDialog
              open={openCancelDialog}
              setOpenCancelDialog={setOpenCancelDialog}
              Remainingpayments={Number(Remainingpayments ?? 0)}
              cancelData={cancelData}
              setCancelData={setCancelData}
              roundValue={roundValue}
              Receivedbalance={() => Number(Receivedbalance ?? 0)}
              // outstangingamount={Number(getorder?.RemainingAmount ?? 0)}
              outstangingamount={Number(outstangingamount)}
              getorder={getorder}
              refundAmount={refundAmount}
              cancelOrder={handleCancel}
            />
          </div>
        </div>
        <ToastContainer />
      </div>
      <PaymentSummaryModal
        model={model}
        setmodel={setmodel}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        deliveryFeeEnabled={deliveryFeeEnabled}
      />
      <CashPaymentSummaryModal
        glowery={glowery}
        setglowery={setglowery}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        inputValue={inputValue}
        handleclick={handleclick}
        handleBlur={handleBlur}
        Outamount={Outamount}
        formatNumber={formatNumber}
        formatNumbers={formatNumbers}
        formattedBalance={formattedBalance}
        outstandingvalue={outstandingvalue}
        deliveryFeeEnabled={deliveryFeeEnabled}
        paymenytMethod={paycard ? "Card" : "Cash"}
      />
      {/* // In OrderDisplay.tsx, update the PaymentConfirmModal usage: */}
      <PaymentConfirmModal
        getorder={getorder || undefined}
        confirm={confirm}
        setConfirm={setConfirm}
        Customer={customer || undefined}
        printData={printData}
        filteredCustomerId={filteredCustomerId}
        Dones={Dones}
        loading={loading}
        onOrderComplete={() =>
          getOrdersIn({
            fetchCustomer: false,
            fetchLedger: true,
            showLoading: true,
          })
        }
      />
      {loading && <LoadingScreen />}
    </div>
  );
};

export default OrderDisplay;
